import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { formValueSelector } from 'redux-form'

import { formatCurrency } from 'ggx-service/i18n/format-currency.service'
import { VoucherModal } from 'ggx-src/billing/voucher/voucher-modal.component'

import { StyledLink, Menu } from './price-breakdown.component.styles'

import { getFeatureFlag } from 'ggx-service/feature-flag/selectors'

const CouponSelection = ({ input, total, discount }) => {
  const [t] = useTranslation()
  const reduxFormSelector = formValueSelector('vanbooking-order')
  const vehicleType = useSelector(state => reduxFormSelector(state, 'vehicle'))
  const [showVoucherModal, setShowVoucherModal] = useState(false)

  const waypoints = useSelector(state =>
    reduxFormSelector(state, 'waypoints_attributes')
  )
  const regionIds = waypoints.map(waypoint => waypoint.region_id)
  const isEnableFixedMovingEeeEnhancement = useSelector(state =>
    getFeatureFlag({
      state,
      featureFlag: 'enable_fixed_moving_fee_enhancement',
    })
  )
  const additionalRequirementKeys = useSelector(state => {
    const details = reduxFormSelector(state, 'order_request_detail_attributes')
    return [
      isEnableFixedMovingEeeEnhancement && details.loading_unloading_fee || details.move_door_to_door ? "loading_unloading_fee" : "",
      details.need_waste ? "need_dump_waste" : "",
      details.need_new_car ? "need_new_car" : "",
      details.need_pet ? "need_pet" : "",
    ].filter(Boolean).join()
  })
  return discount !== undefined ? (
    <StyledLink as="a" noMargin>
      <span>{formatCurrency({ amount: discount })}</span>
      <Menu>
        <Menu.Row noMargin onClick={() => input.onChange([])}>
          {t('remove_coupon')}
        </Menu.Row>
      </Menu>
    </StyledLink>
  ) : (
    <StyledLink as="a" noMargin>
      <span onClick={() => setShowVoucherModal(true)}>{t('add_coupon')}</span>
      {showVoucherModal && (
        <VoucherModal
          orderPrice={total}
          serviceType="transport"
          vehicleType={vehicleType}
          regionIds={regionIds}
          additionalRequirementKeys={additionalRequirementKeys}
          onSelectCoupon={coupon => {
            input.onChange([coupon.available[0].toString()])
          }}
          onModalClose={() => setShowVoucherModal(false)}
        />
      )}
    </StyledLink>
  )
}

CouponSelection.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.array,
    onChange: PropTypes.func,
  }),
  total: PropTypes.number,
  discount: PropTypes.number,
}

export { CouponSelection }
